<div class="row">
  <div
    class="mb-1 item"
    @showEnter
    [class.item-child]="depth > 0"
    [style.margin-left.px]="depth * 24"
    (click)="open()"
  >
    <div class="item-name">
      @if (item?.icon) {
        <div
          class="icon mr-2"
          [ngClass]="item.icon"
        ></div>
      } @else {
        <div class="icon mr-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="#4d4d4d"
            class="w-4 h-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M5 12h14"
            />
          </svg>
        </div>
      }

      <div class="weight mr-2">{{ item.weight }}</div>

      <div class="item-element-name">
        {{ item.name | hardTranslate }}
      </div>
    </div>

    @if (item?.filteredChildren?.length) {
      <div class="item-button">
        <hard-button type="icon">
          <span
            class="text-xs icon-keyboard-arrow-down dropdown-arrow"
            [class.open]="item.show"
          ></span>
        </hard-button>
      </div>
    }

    <div class="item-button">
      <hard-button
        type="icon"
        [classBtn]="'color-yellow'"
        (click)="edit(item); $event.stopPropagation()"
      >
        <span class="icon-pencil"></span>
      </hard-button>
    </div>

    <div class="item-button">
      <hard-button
        type="icon"
        [classBtn]="'color-red'"
        [loading]="item?.loading"
        (click)="remove(item); $event.stopPropagation()"
      >
        <span class="icon-busket"></span>
      </hard-button>
    </div>
  </div>

  @if (item.show) {
    <div>
      @for (child of item?.filteredChildren; track child.id) {
        <ui-menu-item
          [item]="child"
          [menuId]="menuId"
          [slug]="slug"
          [depth]="depth + 1"
          (reloadEmit)="setReload()"
          (openEmit)="edit($event)"
        ></ui-menu-item>
      }
    </div>
  }
</div>
